/* @flow */
import React from 'react';
// $FlowIgnore
import Markdown from 'react-markdown';
// $FlowIgnore
import { FaQuestion } from 'react-icons/fa';
// $FlowIgnore
import { FaExclamation } from 'react-icons/fa';
// $FlowIgnore
import { FaExclamationTriangle } from 'react-icons/fa';
// $FlowIgnore
import { FaClose } from 'react-icons/fa';
import './Banner.css';

import Row from 'components/UIKit/Flex/Row';

const style = {
  headerBanner: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#265986',
    color: 'white',
    padding: '1rem',
    transition: 'all 0.25s ease',
    borderBottom: '1px solid #ebebeb',
  },
  icon: {
    flex: 1,
    paddingLeft: '5px',
    fontSize: '1.2em',
  },
  message: {
    flex: 32,
  },
  dismissButton: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '0 5px 0 0',
  },
  dismissed: {
    borderBottom: 0,
    fontSize: 0,
    height: '0px',
    lineHeight: 0,
    overflow: 'hidden',
    padding: 0,
  },
  warning: {
    backgroundColor: '#D39C3F',
    color: '#231806',
  },
  error: {
    backgroundColor: '#83001E',
  },
};

const levelToIcon = {
  info: <FaQuestion style={style.icon} />,
  warning: <FaExclamation style={style.icon} />,
  error: <FaExclamationTriangle style={style.icon} />,
};

type BannerProps = {
  message: string,
  level: string,
  dismissible: boolean,
  handleOnDismiss: () => {},
  dismissed: boolean,
  isReactElement: boolean,
};

const Banner = ({
  dismissed,
  dismissible,
  handleOnDismiss,
  isReactElement,
  level,
  message,
  ...props
}: BannerProps) => (
  <Row
    className={
      `header-banner no-print${
        dismissed ? ' dismissed' : ''}`
    }
    style={{
      ...style.headerBanner,
      ...(dismissed ? style.dismissed : {}),
      ...(style[level.toLowerCase()] || {}),
    }}
    {...props}
    >
    {levelToIcon[level.toLowerCase()] || levelToIcon.info}

    <span style={style.message}>
      {!isReactElement ? <Markdown source={message} /> : message}
    </span>

    {dismissible && (
      <button
        aria-disabled={dismissed}
        onClick={handleOnDismiss}
        style={style.dismissButton}
        type="button"
        >
        <FaClose />
        {' Dismiss'}
      </button>
    )}
  </Row>
);

export default Banner;
